import * as React from "react";
const SvgFiRrGlassWaterDroplet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.988 3.263a3.01 3.01 0 0 0-.776-2.29A3 3 0 0 0 20 0H4c-.836 0-1.64.353-2.206.967a3.01 3.01 0 0 0-.784 2.279L2.34 19.41C2.55 21.984 4.74 24 7.321 24h9.263a4.97 4.97 0 0 0 4.98-4.562zM3.265 2.322A.99.99 0 0 1 4 2h16c.284 0 .545.115.737.324a1 1 0 0 1 .26.764L19.96 14.873C19.616 15.518 18.805 16 18 16c-.89 0-1.793-.586-2.057-1.333a1 1 0 0 0-1.886 0C13.793 15.414 12.89 16 12 16s-1.793-.586-2.057-1.333a1 1 0 0 0-1.886 0C7.793 15.414 6.89 16 6 16c-.876 0-1.762-.569-2.04-1.299L3.003 3.082a1 1 0 0 1 .261-.76M16.586 22H7.323a3.017 3.017 0 0 1-2.99-2.754l-.136-1.657c.56.26 1.175.411 1.804.411a4.38 4.38 0 0 0 3-1.225 4.38 4.38 0 0 0 3 1.225 4.38 4.38 0 0 0 3-1.225 4.38 4.38 0 0 0 3 1.225c.597 0 1.182-.14 1.718-.377l-.144 1.64a2.98 2.98 0 0 1-2.988 2.736zM12 12c1.93 0 3.5-1.57 3.5-3.5 0-1.048-.632-2.307-1.878-3.743-.818-.942-2.426-.943-3.244 0C9.132 6.193 8.5 7.452 8.5 8.5c0 1.93 1.57 3.5 3.5 3.5m-.11-5.932a.143.143 0 0 1 .222-.001C13.4 7.551 13.5 8.304 13.5 8.499c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5c0-.195.1-.947 1.39-2.431"
    />
  </svg>
);
export default SvgFiRrGlassWaterDroplet;
